import { Utils } from "@/plugins/utils";
import router from '@/router';
import moment from "moment";
import Enums from "../../plugins/Enums";

export default {
	namespaced: true,
	state: {
		lstCf1: [],
		cf1: null,
		insert: false,
		update: false,
		loading: false,
		itemsPerPage: 20,
		search: "",
		hasNext: false,
		tab: 0,
		lstCFG: [],
		hasInstallmentsBlock: false
	},
	getters: {
		getCf1Model(state){
			let cf1 = { ...state.cf1 }
			cf1.cf1abert = Utils.ParseToDate(cf1.cf1abert)
			cf1.cf1datamod = cf1.cf1datamod == '0001-01-01T00:00:00' ? new Date() : Utils.ParseToDate(cf1.cf1datamod)
			cf1.cf1cliente = cf1.cf1cliente.replace(/[^a-zA-Z0-9]/g, '')
			cf1.cf1cep = cf1.cf1cep.replace(/[^\d]/g, "")
			cf1.lstCFG = state.lstCFG
			cf1.cf1id = cf1.cf1id.toString()
			return cf1
		}
	},
	mutations: {
		setLoading: (state, loading) => (state.loading = loading),
		set(state, cf1){
			cf1.cf1abert = new Date(cf1.cf1abert).toLocaleString(navigator.language, { year: "numeric", month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit' })
			if(cf1.cf1datamod == '0001-01-01T00:00:00') 
				cf1.cf1datamod = new Date()
			cf1.cf1datamod = new Date(cf1.cf1datamod).toLocaleString(navigator.language, { year: "numeric", month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit' })
			state.cf1 = cf1
			state.lstCFG = cf1.lstCFG
			if(!!state.cf1 && Object.keys(state.cf1).length > 0 && state.cf1.constructor === Object)
				state.update = true
		},
		initForm(state){
			state.insert = false
			state.update = false
			state.cf1 = null
			state.lstCFG = []
		},
		setParamsDataTable(state, payload){
			state.lstCf1 = payload.items
			state.itemsPerPage = payload.limit
			state.hasNext = payload.hasNext
		},
		setHasInstallmentsBlock(state, payload){
			state.hasInstallmentsBlock = payload
		}
	},
	actions: {
		initForm(store){
			store.commit("initForm")
		},
		async get(store, {cf1cliente, isSilent = false}){
			return await this._vm.$axios.get(`/Customer/Customer/Get/${cf1cliente}`)
				.then(response => {
				return Utils.ValidateAxiosResponse(response.data);
			})
			.catch((error) => {
				if(!isSilent){
					store.dispatch("parameters/showSnackBar", {
						show: true,
						timeout: 2000,
						text: error.message,
						color: "red",
					}, { root: true })
				}
				return null
			});
		},
		async find(store, cf1cliente){
			store.state.loading = true
			store.commit("initForm")
			await store.dispatch("get", { cf1cliente })
			.then(cf1 => {
				if(cf1)
					store.commit("set", cf1)
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
			});
			store.state.loading = false
			return true
		},
		async save(store){
			if (store.state.update){
				return await store.dispatch("update")
			}
			return await store.dispatch("insert")
		},
		async insert(store){
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Salvando", indeterminate: true }, {root: true})
			let payload = await this._vm.$axios.post("/Customer/Customer/Insert", store.getters.getCf1Model )
				.then(response => {
				return Utils.ValidateAxiosResponse(response.data);
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return false
			});
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})
			return payload
		},
		async update(store){
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Salvando", indeterminate: true }, {root: true})
			let payload = await this._vm.$axios.put("/Customer/Customer/Update", store.getters.getCf1Model)
			.then(response => {
				return Utils.ValidateAxiosResponse(response.data);
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return false
			});
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})
			return payload
		},
		async delete(store){
			let cf1cliente = store.state.cf1.cf1cliente.replace(/[^a-zA-Z0-9]/g, '')
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Excluindo", indeterminate: true }, {root: true})
			await this._vm.$axios.delete(`/Customer/Customer/Delete/${cf1cliente}`)
			.then(response => {
				Utils.ValidateAxiosResponse(response.data);
				router.push("/oryxpdv/clientes")
				return true
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return false
			});
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})
		},
		async search(store, { limit = 20, page = 1 }){
			store.state.loading = true
			store.commit("initForm")
			let payload = await this._vm.$axios.get(`/Customer/Customer/Search?search=${store.state.search}&limit=${limit}&page=${page}`)
			.then(response => {
				let payload = Utils.ValidateAxiosResponse(response.data);
				store.commit("setParamsDataTable", payload)
				return true
			})
			.catch((error) => {
				store.state.lstCf1 = []
				store.state.search = ""
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return false
			});
			store.state.loading = false
			return payload
		},
		async findAllIds(store){
			store.state.loading = true
			let payload = await this._vm.$axios.get(`/Customer/Customer/findAllIds`)
			.then(response => {
				let payload = Utils.ValidateAxiosResponse(response.data);
				store.commit("setParamsDataTable", payload)
				return payload
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return []
			});
			store.state.loading = false
			return payload
		},
		async findAllIdsLease(store){
			store.state.loading = true
			let payload = await this._vm.$axios.get(`/Customer/Customer/findAllIdsLease`)
			.then(response => {
				let payload = Utils.ValidateAxiosResponse(response.data);
				store.commit("setParamsDataTable", payload)
				return payload
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return []
			});
			store.state.loading = false
			return payload
		},
		async getReceitaSefaz(store, { cf1cliente, insert = true }){
			store.state.cf1.cf1cliente = cf1cliente
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Buscando dados na Receita Federal e SEFAZ", indeterminate: true }, {root: true})
			let payload = await this._vm.$axios.get(`/Customer/Customer/GetReceitaSefaz/${cf1cliente}?insert=${insert}`)
			.then(response => {
				let payload = Utils.ValidateAxiosResponse(response.data);

				if(payload.isError){
					setTimeout(() => {
						store.dispatch("parameters/openDialog", {
							titleText: "Aviso",
							titleColor: "#f8bb86",
							text: payload.message
						}, { root: true })
					}, 500);
				}

				store.dispatch("mapCf1", payload.cf1)

				return payload.openCustomerForm ? Enums.PayloadCustomerType.OPEN : Enums.PayloadCustomerType.NOT_OPEN
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return Enums.PayloadCustomerType.ERROR
			});
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})
			return payload
		},
		saveCFG(store, cfg){
			if (!store.state.lstCFG){
				store.state.lstCFG = []
			}
			store.state.lstCFG.push(cfg)
		},
		async getSefaz(store, { uf, cpfCnpj}){
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Buscando dados no SEFAZ", indeterminate: true }, {root: true})
			await this._vm.$axios.get(`/Customer/Customer/GetSefaz/${uf}/${cpfCnpj}`)
			.then(response => {
				let customer = Utils.ValidateAxiosResponse(response.data);
				store.dispatch("mapCf1", customer)
				return true
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return false
			});
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})
		},
		async GetReceitaSefazShopping(store, cpfCnpj){
			store.state.cf1.cf1cliente = cpfCnpj

			if (!cpfCnpj)
				return false

			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Buscando dados do cliente", indeterminate: true }, {root: true})
			let payload = await this._vm.$axios.get(`/Customer/Customer/GetReceitaSefazShopping/${cpfCnpj}`)
			.then(response => {
				let customer = Utils.ValidateAxiosResponse(response.data);
				if(!customer)
					return false
				if (customer.mensagensTmp)
					store.dispatch("vd1/showShoppingMessages", customer.mensagensTmp, { root: true })
				if (customer.limitShoppingIntegration)
					store.dispatch("vd1/setLimitShoppingIntegration", customer.limitShoppingIntegration, { root: true })
				store.dispatch("mapCf1", customer)

				return true
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return false
			});
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})
			return payload
		},
		async getShopping(store, { cf1cliente, cart = false, insert = true }){
			if (!cf1cliente)
				return false

			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Buscando dados do cliente", indeterminate: true }, {root: true})
			let payload = await this._vm.$axios.get(`/Customer/Customer/GetShopping/${cf1cliente}?cart=${cart}&insert=${insert}`)
			.then(response => {
				let payload = Utils.ValidateAxiosResponse(response.data);
				if (!!payload.cf1 && payload.cf1.mensagensTmp)
					store.dispatch("vd1/showShoppingMessages", payload.cf1.mensagensTmp, { root: true })
				if (!!payload.cf1 && payload.cf1.limitShoppingIntegration)
					store.dispatch("vd1/setLimitShoppingIntegration", payload.cf1.limitShoppingIntegration, { root: true })

				if(payload.isError){
					setTimeout(() => {
						store.dispatch("parameters/openDialog", {
							titleText: "Aviso",
							titleColor: "#f8bb86",
							text: payload.message
						}, { root: true })
					}, 500);
				}

				store.dispatch("mapCf1", payload.cf1)

				return payload.openCustomerForm ? Enums.PayloadCustomerType.OPEN : Enums.PayloadCustomerType.NOT_OPEN
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return Enums.PayloadCustomerType.ERROR
			});
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})
			return payload
		},
		async findToCartWithShopping(store, { cf1cliente = null }){
			if (!cf1cliente)
				return null

			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Buscando dados do cliente", indeterminate: true }, {root: true})
			let payload = await this._vm.$axios.get(`/Customer/Customer/FindToCartWithShopping/${cf1cliente}`)
			.then(response => {
				let payload = Utils.ValidateAxiosResponse(response.data);
				if (payload.cf1.mensagensTmp)
					store.dispatch("vd1/showShoppingMessages", payload.cf1.mensagensTmp, { root: true })
				if (payload.cf1.limitShoppingIntegration)
					store.dispatch("vd1/setLimitShoppingIntegration", payload.cf1.limitShoppingIntegration, { root: true })

				if(payload.isError){
					store.dispatch("parameters/openDialog", {
						titleText: "Aviso",
						titleColor: "#f8bb86",
						text: payload.message
					}, { root: true })
				}

				return payload.cf1
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return null
			});
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})
			return payload
		},
		initModel(store){
			store.state.insert = true
			store.state.cf1 = {
				cf1cliente: "",
				cf1nome: "",
				cf1fant: "",
				cf1tipo: "",
				cf1codant: "",
				cf1ender1: "",
				cf1ender2: "",
				cf1observa: "",
				cf1cep: "",
				cf1insest: "",
				cf1contato: "",
				cf1condpto: "",
				cf1confone: "",
				cf1conandi: "",
				cf1conanme: "",
				cf1fone: "",
				cf1fax: "",
				cf1email: "",
				cf1repres: "",
				cf1redesp: "",
				cf1aviso: "",
				cf1usuario: "",
				cf1abert: moment().format("DD-MM-YYYY HH:mm"),
				cf1datamod: moment().format("DD-MM-YYYY HH:mm"),
				cf1transp: "",
				cf1login: "",
				cf1senha: "",
				cf1concpf: "",
				cf1conanan: "",
				cf1conmail: "",
				cf1site: "",
				cf1bairro: "",
				cf1numero: "",
				cf1compl: "",
				cf1etiq: "",
				cf1suframa: "",
				cf1opercom: "",
				cf1inscmun: "",
				cf1cnae: "",
				cf1conpgto: "",
				cf1descon: 0,
				cf1latit: 0,
				cf1longit: 0,
				cf1prgprot: false,
				cf1emailnf: "",
				cf1foto1: "",
				cf1foto2: "",
				cf1foto3: "",
				cf1foto4: "",
				cf1origem: 0,
				cf1id: 0,
				cf3nome: "",
				cf3estado: "",
				shippingAddress: null,
				blocks: [],
				rule: "",
				lstCFG: [],
				returns: [],
				amountPurchase: 0,
				step: 0,
				cf1contrib: false,
				cf1entegov: Enums.GovernmentEntityTypeEnum.NONE
			}
			store.state.lstCFG = []
			store.dispatch("cfa/setInsert", true, {root: true})
			return true
		},
		mapCf1(store, customer){
			delete customer.cf1abert
			delete customer.cf1datamod
			Object.keys(customer).forEach(key => {
				if (customer[key] || key == "cf1contrib" || key == "cf1entegov") {
					store.state.cf1[key] = customer[key]
				}
			});
			if(store.state.lstCFG == null || store.state.lstCFG.length == 0)
				store.state.lstCFG = customer.lstCFG
			else{
				if(customer.lstCFG != null){
					store.state.lstCFG = store.state.lstCFG.filter(cfg => cfg.cfgcliente == customer.cf1cliente)
					for (const cfg of customer.lstCFG) {
						if(!store.state.lstCFG.filter(c => c.cfgcnae == cfg.cfgcnae)[0])
							store.state.lstCFG.push(cfg)
					}
				}
			}
		},
		async getCustomerCredit({ state }, cf1cliente){
			return await this._vm.$axios.get(`/Customer/Customer/GetCreditLimitByCliente/${cf1cliente}`)
			.then(response => {
				let payload = Utils.ValidateAxiosResponse(response.data);			
	
				return payload
			})
			.catch((error) => {
				state.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return false
			});
		},
		async findCf1Validation(store, cf1cliente){
			return await this._vm.$axios.get(`/Customer/Customer/ValidateCf1/${cf1cliente}`)
			.then(response => {
				let payload = Utils.ValidateAxiosResponse(response.data);
				store.commit("setHasInstallmentsBlock", payload.installmentsBlockCustomer)
				return payload
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return null
			});
		},
		async validateCf1(store, cf1cliente){
			const payload = await store.dispatch("findCf1Validation", cf1cliente)

			if (!payload) return false

			if (payload.message) {
				store.dispatch("parameters/showSnackBar", {
					show: true,
					timeout: 3000,
					text: payload.message,
					color: "#f8bb86"
				}, { root: true })
				return !payload.fullBlockCustomer
			}

			return true
		},
		async findAmountSalesByLastYear(store, cf1cliente){
			return await this._vm.$axios.get(`/Customer/Customer/FindAmountSalesByLastYear/${cf1cliente}`)
			.then(response => {
				return  Utils.ValidateAxiosResponse(response.data);
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return 0
			});
		},
		async findCustomerHistory(store, { cf1cliente, fromCv5emissao, toCv5emissao, lstCv5tipo, entsai	}){
			let model =  await this._vm.$axios.post(`/Customer/Customer/FindCustomerHistory/${cf1cliente}`, {
				fromCv5emissao,
				toCv5emissao,
				lstCv5tipo,
				entsai
			})
			.then(response => {
				return  Utils.ValidateAxiosResponse(response.data);
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return {
					lstFiscalDocTypes: [],
					lstHistory: [],
				}
			});
			return model
		},
		async findCustomerHistoryPayments(store, { cv5doc, cv5tipo, cv5emissor, cv5pedido }){
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Buscando parcelas da venda", indeterminate: true }, {root: true})
			let model =  await this._vm.$axios.get(`/Customer/Customer/FindCustomerHistoryPayments/${cv5doc}/${cv5tipo}/${cv5emissor}/${cv5pedido}`)
			.then(response => {
				return  Utils.ValidateAxiosResponse(response.data);
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return null
			});
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})
			return model
		},
		async importPassengers(store, lstCf1){
			let lstErrors = []
			let index = 1
						for (const cf1 of lstCf1) {
								store.dispatch("parameters/openGlobalLoading", {
										showLoadingGlobal: true,
										text: `Salvando cliente: ${index} de ${lstCf1.length}<br/>Aguarde tomando um cafézinho ☕`,
										size: 100,
										rotate: -90,
										value: (index/lstCf1.length)*100,
					opacity: 0.6
								}, {root: true})

				let success = await this._vm.$axios.post("/Customer/IntegrationRepresentative/ImportPassenger", cf1)
				.then(response => {
					return Utils.ValidateAxiosResponse(response.data);
				})
				.catch((error) => {

					lstErrors.push({
						cf1cliente: cf1.cf1cliente,
						cf1nome: cf1.cf1nome,
						reason: error.message
					})
					return true
				});

				store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})
				if (!success) {
					return success
				}
				index++
			}

			if (!!lstErrors && lstErrors.length > 0) {
				let message = "Não foi possível importar os seguintes clientes:<br/><ul>"
				lstErrors.forEach(error => {
					message+="<li><b>CPF/CNPJ: </b>"+error.cf1cliente + " <b>Nome: </b>"+error.cf1nome+" <b>Motivo: </b>"+error.reason+"</li>"
				});
				message+="</ul>"
				store.dispatch("parameters/openDialog", {
						titleText: "Clientes não importados",
						titleColor: "red",
						maxWidth: 1000,
						text: message
					}, { root: true })
				return false
			}

			return true
		},
		async findCv3estadoByCf1cliente({ commit, dispatch }, cf1cliente){
			dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Buscando estado", indeterminate: true }, {root: true})
			var payload = await this._vm.$axios.get(`/Customer/Customer/FindUfByCf1cliente/${cf1cliente}`)
			.then(response => {
				return  Utils.ValidateAxiosResponse(response.data);
			})
			.catch((error) => {
				dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return null
			});
			dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})
			return payload
		},
	}
}
